
export const config = {
  id: 'synthwave',
  name: 'Synthwave',
  icon: 'sun',
  color: 'pink',
  welcomeMessage: "Welcome to the retro future! Let's ride the neon wave together.Start a chat.",
  typography: "'VT323', monospace",
  description: 'A synthwave visual style.',
  preview: 'Cruising through the digital grid to start a chat.write your first message.',
  suggestedPrompts: [
    { text: 'Load retro interface' },
    { text: 'Play 80s tunes' },
    { text: 'Enter the grid' },
  ],
  animation: {
    messageIn: 'synthwave-scan',
    messageOut: 'synthwave-fade',
    typing: 'synthwave-typing',
    avatar: 'synthwave-avatar-spin',
    button: 'synthwave-scan',
    grid: true,
    sun: true,
    mountains: true
  },
  transitions: {
    duration: '0.5s',
    timing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    hover: '0.3s ease-in-out'
  },
  effects: {
    glow: 'shadow-lg shadow-pink-500/50',
    hover: 'translateY(-2px)',
    focus: 'ring-2 ring-pink-400',
    active: 'scale-95',
    grid: true,
    sun: true,
    mountains: true,
    perspective: true
  },
  embedCode: `<script src="chatbot-loader.js"></script>
<script>
window.chatConfig = {
  theme: "synthwave",
  color: "#EC4899",
  typography: "VT323, monospace",
  welcomeMessage: "Welcome to the retro future! Let's ride the neon wave together.",
  userId: "user_synth_123",
  chatbotId: "bot_synth_001",
  animations: {
    enabled: true,
    duration: "0.5s",
    effects: {
      grid: true,
      sun: true,
      mountains: true,
      perspective: true
    }
  }
};
</script>`
}; 